module.exports = __webpack_public_path__ + "img/产品中心 条幅2.e460ae28.jpg";